import { computed, type ComputedRef } from 'vue';
import { useRoute } from 'vue-router';

export enum FeatureToggles {
  AGENCY_AGENTS = 'agency_agents',
}

export const DEFAULT_FEATURES_VALUE: Record<FeatureToggles, boolean> = {
  [FeatureToggles.AGENCY_AGENTS]: false,
};

const useFeatureToggle = (toggle: FeatureToggles): ComputedRef<boolean> => {
  const route = useRoute();

  return computed(() => {
    return route.query[toggle] === 'true' || DEFAULT_FEATURES_VALUE[toggle];
  });
};

export default useFeatureToggle;
